import React, { Component } from "react";
import Routes from "./routes";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";

class Manager extends Component {
  constructor(props) {
    super(props);
    this.weekDate = undefined
    this.state = {

    };
  }
  render() {
    return (
      <>
        <Routes dateDataUp={(data) => {
          this.weekData = data
        }} {...this.props.match}
          dateData={this.weekData} />
      </>
    );
  }
}
const mapStateToProps = ({ auth }) => {
  return {
    ssoId: auth.ssoId
  };
};
export default withRouter(connect(mapStateToProps)(withTranslation()(Manager)));
